export default function updateProperties<T>(target: T, source: Partial<T>): void {
    for(const key in target) {
        if(Object.prototype.hasOwnProperty.call(target, key) && source[key] !== undefined) {
            target[key] = source[key] as T[typeof key]
        }
    }
}
